export const columnsDataDevelopment = [
  {
    Header: "TIMESTAMP",
    accessor: "tmstamp", 
  },
  {
    Header: "Via",
    accessor:"channel",
  },
  {
    Header: "USER ID",
    accessor: "sender",
  },
  {
    Header: "MESSAGE",
    accessor: "message",
  },
  {
    Header: "NODEREF",
    accessor: "node_key",
  },
  {
    Header: "ACCURACY",
    accessor: "resp_accuracy",
  }
];
